import React, { Fragment } from 'react';

import { Link } from '@zapier/design-system';

const views = {
  ['DEFAULT']: () => ({
    bodyText: (
      <Fragment>
        To turn on your Zap, you'll need access to{' '}
        <Link href="/apps/categories/premium" target="_blank">
          Premium Apps
        </Link>
        . Edit your Zap or upgrade now to turn on your Zap.
      </Fragment>
    ),
    type: 'DEFAULT',
  }),

  ['TRIAL_EXTENSION']: () => ({
    bodyText: (
      <Fragment>
        To turn on your Zap, you'll need access to{' '}
        <Link href="/apps/categories/premium" target="_blank">
          Premium Apps
        </Link>
        . Upgrade now or start a free 7-day trial of the Professional plan to
        use unlimited Premium Apps.
      </Fragment>
    ),
    type: 'TRIAL_EXTENSION',
  }),
};

type Props = {
  canExtendTrial: boolean;
};

export const getActiveView = ({ canExtendTrial }: Props) =>
  canExtendTrial ? views.TRIAL_EXTENSION() : views.DEFAULT();
